/**
 * Loader component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';

import './styles.scss';

@connect(
    (store) => ({
        text: store.invite.data?.data?.name,
    }),
)
export default class Loader extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        global: PropTypes.bool,
        inverse: PropTypes.bool,
        text: PropTypes.string,
        withText: PropTypes.bool,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        global: false,
        inverse: false,
        text: undefined,
        withText: true,
    };

    render () {
        const { global, inverse, text, withText } = this.props;

        return (
            <div
                id="loader"
                className={ cx({
                    global,
                    inverse,
                }) }
            >
                <div className="loader-content">
                    <div className="loader-content-line"/>
                    <div className="loader-content-ball"/>
                    { withText && <h4>
                        { text }
                        { !text && <FormattedMessage id="name"/> }
                    </h4> }
                </div>
            </div>
        );
    }
}
